<template>
  <v-layout wrap class="container px-2 py-0">
    <v-layout wrap>
      <v-flex xs12 pb-0>
        <v-layout wrap align-center>
          <v-flex
            xs12
            mt-3
          >
            <h1 class="headline">{{ $t('notFound.title') }}</h1>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
export default {
  name: 'NotFoundPage',
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
  },
};
</script>

<style lang="scss" scoped>
</style>
